import React from "react"
import { makeStyles } from "@mui/styles"
import { COLORS } from "../../utils"
import Typography from "@mui/material/Typography"
import Icon from "@mui/material/Icon"
import BuildIcon from "@mui/icons-material/Build"

const useStyles = makeStyles({
    container: {
        display: "flex",
        alignItems: "center"
    },
    title: {
        color: COLORS.DARK_BLACK
    },
    icon: {
        marginRight: 10,
        color: COLORS.DARK_BLACK,
        height: 24
    }
})

const MiscHeaderTitle = () => {

    const classes = useStyles()

    return (
        <div className={classes.container}>
            <Icon className={classes.icon}>
                <BuildIcon />
            </Icon>
            <Typography variant="h6" color="textPrimary" className={classes.title}>
                Divers
            </Typography>
        </div>
    )
}

export default MiscHeaderTitle
